import React from 'react';
import { Badge } from '@nooz-optics/nooz-components-lib';
import { IProduct } from '../../../../utils/types/contentful';
import { ProductMainVariantDetails } from './Details/productMainVariantDetails';
import { ProductMainVariantImages } from './VariantImages/productMainVariantImages';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { LifestyleImages } from './LifestyleImages/lifeStyleImages';
import { useMediaQuery } from '../../../../utils/hooks/useMediaQuery';

export interface ProductMainProps {
  product: IProduct;
}

export const ProductMain: React.FC<ProductMainProps> = ({
  product,
  variant,
  productUsp,
  productMainDetails,
}) => {
  const isWindowSmallSize = useMediaQuery('lg');

  const productImages =
    isWindowSmallSize && variant.lifestyleImages
      ? [...variant.images, ...variant.lifestyleImages]
      : isWindowSmallSize && product.lifestyleImages
      ? [...variant.images, ...product.lifestyleImages]
      : variant.images;

  const returnBadges = () => {
    let allBadges = [];

    // Categories
    if (product.categories && product.categories.length > 0) {
      allBadges = [
        product.categories?.map((cat) => (
          <div className='mb-2'>
            <Badge
              size='sm'
              type='simple'
              dotColor={cat.color}
              dotIcon={cat.icon}
              label={cat.label}
            />
          </div>
        )),
      ];
    }

    // Categories
    if (product.collection && product.collection.badge) {
      allBadges = [
        ...allBadges,
        <div className='mb-2'>
          <Badge
            {...product.collection.badge}
            type='simple'
            size='sm'
          />
        </div>,
      ];
    }

    // Badges
    if (product.badges && product.badges.length > 0) {
      allBadges = [
        product.badges?.map((badge) => (
          <div className='mb-2'>
            <Badge
              {...badge}
              type='simple'
              size='sm'
            />
          </div>
        )),
      ];
    }

    // Promotion
    if (variant.promotion && variant.promotion.badge) {
      allBadges = [
        ...allBadges,
        <div className='mb-2'>
          <Badge
            size='sm'
            {...variant.promotion.badge}
          />
        </div>,
      ];
    }

    return allBadges;
  };

  return (
    <div className='relative'>
      <div className='absolute w-full lg:w-1/2 right-0 h-full bg-gray-100' />
      <div className='flex justify-center items-center w-screen bg-white'>
        <div className='absolute w-2/3 left-0 bg-gray-100' />
        <div
          className={`relative w-full justify-center flex flex-wrap ${
            isWindowSmallSize ? '' : 'main-wrapper'
          }`}>
          <div className='relative w-full lg:w-2/3 bg-white'>
            <ProductMainVariantImages
              badges={returnBadges()}
              categories={product.categories}
              images={productImages}
            />
          </div>
          <div className='main-wrapper relative w-full pb-20 lg:pl-8 lg:w-1/3 bg-gray-100'>
            <ProductMainVariantDetails
              {...formatContentfulComponentProps(productMainDetails)}
              product={product}
              variant={variant}
              productUsp={productUsp}
            />
          </div>
        </div>
      </div>
      <div className='relative'>
        {(variant.lifestyleImages?.length > 0 ||
          product.lifestyleImages?.length > 0) && (
          <LifestyleImages
            images={variant?.lifestyleImages || product?.lifestyleImages}
          />
        )}
      </div>
    </div>
  );
};
